import React from "react";

const UploadIcon = props => {
  return (
    <svg
      className={props.class}
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 24 22"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
    >
      <path d="M23.1505 10.7255C22.7712 10.7255 22.4677 11.0277 22.4677 11.4056V17.5919C22.4677 19.2746 21.0919 20.6398 19.4076 20.6398H4.42576C2.73638 20.6398 1.36566 19.2695 1.36566 17.5919V11.3048C1.36566 10.927 1.06218 10.6247 0.682831 10.6247C0.30348 10.6247 0 10.927 0 11.3048V17.5919C0 20.0252 1.9878 22 4.42576 22H19.4076C21.8506 22 23.8333 20.0202 23.8333 17.5919V11.4056C23.8333 11.0328 23.5299 10.7255 23.1505 10.7255Z"></path>
      <path d="M8.05759 5.48615L11.234 2.32242V16.1209C11.234 16.4987 11.5375 16.801 11.9168 16.801C12.2962 16.801 12.5997 16.4987 12.5997 16.1209V2.32242L15.7761 5.48615C15.9076 5.61713 16.0846 5.68766 16.2566 5.68766C16.4336 5.68766 16.6056 5.62217 16.7371 5.48615C17.0052 5.21914 17.0052 4.79093 16.7371 4.52393L12.3974 0.201511C12.2709 0.0755667 12.0939 0 11.9168 0C11.7348 0 11.5628 0.070529 11.4363 0.201511L7.09656 4.52393C6.82849 4.79093 6.82849 5.21914 7.09656 5.48615C7.35958 5.74811 7.79457 5.74811 8.05759 5.48615Z"></path>
    </svg>
  );
};

export default UploadIcon;
